"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const checkIfEnrolmentExists_1 = require("../../helpers/enrolment/checkIfEnrolmentExists");
const applyAssignOffer_1 = require("./applyAssignOffer");
const updateRootEnrolmentAndGenerateEvent_1 = require("./updateRootEnrolmentAndGenerateEvent");
function applyAdminAssignOffer(command, user, content, states, enrolments, stateInteractions) {
    // check if root enrolment exists
    const isAlreadyAssignedContent = checkIfEnrolmentExists_1.checkIfNonDeletedEnrolmentExists(enrolments, content._id, user);
    if (!isAlreadyAssignedContent) {
        return applyAssignOffer_1.applyAssignOffer(command, user, content, states, enrolments, stateInteractions);
    }
    return updateRootEnrolmentAndGenerateEvent_1.updateRootEnrolmentAndGenerateEvent(states, enrolments, command, content, user, stateInteractions);
}
exports.applyAdminAssignOffer = applyAdminAssignOffer;
//# sourceMappingURL=applyAdminAssignOffer.js.map